import React from 'react';
import { View, ScrollView, Dimensions, TouchableWithoutFeedback } from 'react-native';
import { connect } from 'react-redux';
import queryString from "query-string";
import ReactPlayer from 'react-player';

import { addContentToUserProgress } from "../../../../redux/actions";

import Colors from "../../../../constants/Colors";
import {KnowledgeElementTitle} from "../KnowledgeElementTitle";
import {KnowledgeElementShortDescription} from "../KnowledgeElementShortDescription";
import get from "../../../../api/methods/get";
import {CONTENT_GET_SPECIFIC} from "../../api/journeyEndpoints";
import {SpinnerControl} from "../../../../components";
import NavBar from "../../../../components/NavBar";

class Video extends React.Component {

    static navigationOptions = ({navigation}) => {
        return {
            title: 'Vídeo',
        }
    };

    state = {
        isFetching: false,
        contentData: null,
    }

    fetchOriginal = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });

        try {

            const values = queryString.parse(this.props.location.search);
            const contentId = values.contentId;
            let result = await get(CONTENT_GET_SPECIFIC("video", contentId));
            let json = await result.json()

            // await this.props.addContentToUserProgress('video', contentId);

            this.setState({ contentData: json.data });
        } catch (e) {

        }

        this.setState({ isFetching: false });
    }

    //TODO(Celso): Adicionar envio de atividade completa!
    handleVideoClick = async () => {

        try {
            const isCompleted = this.props.location.state.isCompleted;
            if (isCompleted === true) return;

            const values = queryString.parse(this.props.location.search);
            const contentId = values.contentId;
            await this.props.addContentToUserProgress('video', contentId);
        } catch (e) {
            console.log(e);
        }
    }

    componentDidMount() {
        this.fetchOriginal()
    }

    render() {

        const { height, width } = Dimensions.get('window');

        return (
            <NavBar title={'Vídeo'}>

                <SpinnerControl
                    isFetching={this.state.isFetching}
                    text={"Estamos carregando o conteúdo!"}
                />

                {
                    this.state.contentData !== null &&
                        <View style={{ width: 600 }}>
                            <KnowledgeElementTitle title={this.state.contentData.title} />

                            {
                                (this.state.isFetching === false && this.state.contentData !== null) &&
                                    <ReactPlayer
                                        url={this.state.contentData.videoURL}
                                        width={600}
                                        height={400}
                                        controls={true}
                                        // onStart={() => this.handleVideoClick()}
                                        onEnded={() => this.handleVideoClick()}
                                    />
                            }

                            <KnowledgeElementShortDescription shortDescription={this.state.contentData.shortDescription} />

                        </View>
                }
            </NavBar>
        )
    }

}

const mapStateToProps = state => {
    return {  }
}

export default connect(mapStateToProps, { addContentToUserProgress })(Video);
